"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var deg2rad = function deg2rad(deg) {
  return deg * (Math.PI / 180);
};
var MILES_IN_KM = 0.62137119;

var distanceInMiles = exports.distanceInMiles = function distanceInMiles() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return distance * MILES_IN_KM;
};

var distanceBetweenLatLons = function distanceBetweenLatLons(lat1, lon1, lat2, lon2, usesMetricSystem) {
  var R = 6371; // radius of the earth in km
  var dLat = deg2rad(lat2 - lat1);
  var dLon = deg2rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // distance in km

  if (usesMetricSystem) {
    return d;
  }

  return distanceInMiles(d);
};

// items is an array of [{ latitude, longitude }, obj] pairs
var sortByDistance = exports.sortByDistance = function sortByDistance(location, items) {
  var distanceObjectPairs = items.map(function (item) {
    return [distanceBetweenLatLons(location.latitude, location.longitude, item[0].latitude, item[0].longitude), item[1]];
  });

  distanceObjectPairs.sort(function (a, b) {
    return a[0] - b[0];
  });

  return distanceObjectPairs.map(function (pair) {
    return pair[1];
  });
};